module.exports = __webpack_public_path__ + "static/media/sass.5d1ce412.svg";